module.exports = __webpack_public_path__ + "static/media/shape_3.6397e07b.png";